export const USER_ROLE = {
  ADMIN: 'admin',
  CURATOR: 'curator',
  USER: 'user',
};

export const MIN_PASSWORD_LENGTH = 8;
